/**
 * Afoulki GPS — ISOLATED provider adapter.
 *
 * Afoulki (https://afoulki.gps1.ma) runs on the GPSWOX platform, so it speaks the
 * same API as the existing providers. This adapter therefore REUSES the proven,
 * read-only GPSWOX fetcher (`traccarFetchAll`) but with Afoulki's OWN isolated
 * credentials — it does not modify any existing provider logic or settings.
 *
 * Auth: email + password only (as the platform requires).
 * Returns the SAME normalized shape as traccarFetchAll(), so the rest of the app
 * (sync loop, markers, history, stats, status) works unchanged.
 */

import { traccarFetchAll } from './traccar';

const DEFAULT_URL = 'https://afoulki.gps1.ma';

export const afoulkiFetchAll = async (settings = {}) => {
  const url = (settings.afoulkiUrl || DEFAULT_URL).replace(/\/+$/, '');
  if (!settings.afoulkiEmail || !settings.afoulkiPassword) {
    return { success: false, error: 'Afoulki: email et mot de passe requis', data: [] };
  }

  // Delegate to the GPSWOX fetcher with Afoulki's isolated credentials.
  // We pass a SEPARATE settings object (not the real one) so the main
  // GPSWOX/Traccar configuration is never read or altered.
  return traccarFetchAll({
    traccarEnabled: true,
    traccarUrl: url,
    traccarEmail: settings.afoulkiEmail,
    traccarPassword: settings.afoulkiPassword,
    traccarProvider: 'afoulki',
    traccarRefreshSec: settings.traccarRefreshSec,
    corsProxy: settings.corsProxy
  });
};
